import { Component } from '@angular/core';

@Component({
  selector: 'app-rag-logo',
  templateUrl: './rag-logo.component.html',
  styleUrls: ['./rag-logo.component.scss'],
})
export class RagLogoComponent {}
